<div class="content-block has-padding"
	 [class.block-loader]="(currentSubsidiaryLoader.isLoading$ | async) || (subsidiaryFormLoader.isLoading$ | async)">
	<loader-spinner [model]="currentSubsidiaryLoader"/>
	<loader-spinner [model]="subsidiaryFormLoader"/>

	<form [formGroup]="form" (submit)="onSubmit()" autocomplete="off">

		<div class="row">
			<div class="col-lg-6">
				@if (countries$ | async; as countries) {
					<div class="form-group">
						<label class="form-label" translate="SubsidiaryDetail.Company.Country"></label>
						<ng-select
							[items]="countries"
							formControlName="countryCode"
							bindValue="countryCode"
							bindLabel="countryName"
							[readonly]="true"
							[minTermLength]="3"
							class="ng-select-custom ng-select-custom-alt"
							[class.is-invalid]="countryCodeField.dirty && countryCodeField.invalid"
							notFoundText="{{ 'Forms.FieldErrorMessages.NoResult' | translate }}"
							typeToSearchText="{{ 'Actions.Search' | translate }}"
							placeholder="{{ 'Forms.SelectDefault' | translate }}"
							[class.hide-arrow]="true"
						/>
						<form-control-feedback [field]="countryCodeField"/>
					</div>
				}
			</div>
			<div class="col-lg-6">

				<div class="form-group">
					<label class="form-label form-label-required"
						   for="field-legalIdentifier">{{ (isFrance ? 'NewAccount.Company.Siret' : 'NewAccount.Company.Identifier') | translate }}</label>
					<input type="text" class="form-control form-control-alt" id="field-legalIdentifier"
						   [value]="legalIdentifierField.value ? legalIdentifierField.value : '-'" disabled/>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-lg-6">

				<div class="form-group">
					<label class="form-label form-label-required" for="field-name" translate="SubsidiaryDetail.Company.Name"></label>
					<input type="text" autocomplete="off" class="form-control form-control-alt" id="field-name"
						   formControlName="name" [class.is-invalid]="nameField.dirty && nameField.invalid"/>
					<form-control-feedback [field]="nameField"/>
				</div>
			</div>

			<div class="col-lg-6">

				<div class="form-group">
					<label class="form-label form-label-required" for="field-address" translate="SubsidiaryDetail.Company.Street"></label>
					<input type="text" autocomplete="off" class="form-control form-control-alt" id="field-address"
						   formControlName="street" [class.is-invalid]="streetField.dirty && streetField.invalid"/>
					<form-control-feedback [field]="streetField"/>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-lg-6">

				<div class="form-group">
					<label class="form-label form-label-required" for="field-zip-code" translate="SubsidiaryDetail.Company.ZipCode"></label>
					<input type="text" autocomplete="off" class="form-control form-control-alt" id="field-zip-code"
						   formControlName="zipCode" [class.is-invalid]="zipCodeField.dirty && zipCodeField.invalid"/>
					<form-control-feedback [field]="zipCodeField"/>
				</div>
			</div>

			<div class="col-lg-6">

				<div class="form-group">
					<label class="form-label form-label-required" for="field-city" translate="SubsidiaryDetail.Company.City"></label>
					<input type="text" autocomplete="off" class="form-control form-control-alt" id="field-city"
						   formControlName="city" [class.is-invalid]="cityField.dirty && cityField.invalid"/>
					<form-control-feedback [field]="cityField"/>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-lg-6">
				<div class="form-group">
					<label class="form-label form-label-required" for="field-currency-code"
						   translate="SubsidiaryDetail.Company.CurrencyCode"></label>
						<ng-select
						   [items]="currencies$ | async"
						   [readonly]="true"
						   formControlName="currencyCode"
						   bindValue="currencyCode"
						   bindLabel="currencyName"
						   class="ng-select-custom ng-select-custom-alt"
						   [class.is-invalid]="currencyCodeField.dirty && currencyCodeField.invalid"
						   notFoundText="{{ 'Forms.FieldErrorMessages.NoResult' | translate }}"
						   typeToSearchText="{{ 'Actions.Search' | translate }}"
						   placeholder="{{ 'Forms.SelectDefault' | translate }}"
						   [class.hide-arrow]="true"
					   />
					<form-control-feedback [field]="currencyCodeField"/>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="form-group">
					<label class="form-label form-label-required" for="field-annual-figure"
						   translate="SubsidiaryDetail.Company.AnnualFigure"></label>
					<div class="input-group">
						<input type="text" currencyMask autocomplete="off" class="form-control form-control-alt"
								id="field-annual-figure" formControlName="annualFigure"
								[class.is-invalid]="annualFigureField.dirty && annualFigureField.invalid"/>
						@if (currencySymbol$ | async; as symbol) {
							<div class="input-group-append">
								<span class="input-group-text">{{ symbol }}</span>
							</div>
						}
					</div>
					<form-control-feedback [field]="annualFigureField"/>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-lg-6">
				<div class="form-group">
					<label class="form-label" for="field-logo">
						{{ 'NewAccount.Company.Logo' | translate }}
						<i class="far fa-info-circle" ngbTooltip="{{ 'NewAccount.Company.LogoTooltip' | translate }}"></i>
					</label>
					@if ((!hadPreviousLogo || isLogoDeletedField.value || logoField.value.underlyingFile) && (isEditing$ | async)) {
						<div class="row">
							<file-upload class="col-lg-6" formGroupName="logo"
								[form]="logoField"
								[readonly]="logoField.disabled"
								[config]="fileConfig"
								[delegateUpload]="false"
								buttonKey="NewAccount.Company.UploadFile"
								(selection)="isLogoDeletedField.setValue(false)"
							/>
							<file-upload-instructions [config]="fileConfig" class="col-lg-6"/>
						</div>
					}
					@if (logoUrl && !isLogoDeletedField.value && !logoField.value.underlyingFile) {
						<div class="file-uploader-chip">
							@if (logoUrl) {
								<img [src]="logoUrl" />
							}
							@if (isEditing$ | async) {
								<button type="button" class="file-uploader-delete" (click)="isLogoDeletedField.setValue(true)"></button>
							}
						</div>
					}
					@if (!(logoUrl && !isLogoDeletedField.value && !logoField.value.underlyingFile?.value) && (isEditing$ | async) === false) {
						<div class="form-label">
							<span class="logo-info" translate="NewAccount.Company.LogoMissing"></span>
						</div>
					}

					<form-control-feedback [field]="logoField"/>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="form-group">
					<div class="form-check">
						<label class="form-label" for="field-salesConditionsAccepted"><br></label>
						<br><input id="field-contact-salesConditionsAccepted" class="form-check-input" type="checkbox" formControlName="salesConditionsAccepted" />
						<label class="form-check-label" for="field-contact-salesConditionsAccepted">{{ 'NewAccount.Company.AcceptSalesConditions' | translate }} <a (click)="openSalesConditions($event)" href="#" translate="NewAccount.Company.AcceptSalesConditionsLink"></a></label>
						<form-control-feedback [field]="salesConditionsAcceptedField"/>
					</div>
				</div>
			</div>
		</div>

		<div class="form-text" translate="Forms.RequiredFields"></div>

		<div class="form-actions form-actions-spaced">
			@if (isEditing$ | async) {
				<button (click)="cancel()" class="btn btn-light" type="button"
					translate="Actions.Cancel" data-cy="Cancel"></button>

				<button [disabled]="form.invalid" class="btn btn-primary" type="submit"
					translate="Actions.Save" data-cy="Save"></button>
			}
			@else {
				<button (click)="onToggleEditing()" class="btn btn-secondary" type="button"
					translate="Actions.EditInformations" data-cy="EditInformations"></button>
			}

		</div>
	</form>
</div>
